import React, { useState } from 'react'
import useToken from "./useToken";
import { Container, AppBar, Toolbar, Typography, Button, TextField, Select, MenuItem, Grid, Checkbox, FormControlLabel, Snackbar, Backdrop, CircularProgress } from '@mui/material'; // Backdrop, CircularProgress, Snackbar hozzáadva
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import MuiAlert from '@mui/material/Alert';
import moment from 'moment';
import 'moment/locale/hu';

moment.updateLocale('hu', { week: { dow: 1 } });

const Notification = React.forwardRef(function Notification(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Home() {
    const { token } = useToken();
    const [date, setDate] = useState(moment());
    const [taskCode, setTaskCode] = useState('')
    const [testResult, setTestResult] = useState('Helyes')
    const [timeSpent, setTimeSpent] = useState(0)
    const [showAUTCheckbox, setShowAUTCheckbox] = useState('no')
    const [includeRemaining, setIncludeRemaining] = useState('no')
    const [worklogComment, setWorklogComment] = useState('');
    const [logDate, setLogDate] = useState(moment());
    const [apiResult, setApiResult] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const options = [
        { value: 'Helyes', label: 'Helyes' },
        { value: 'Hibás', label: 'Hibás' },
        { value: 'Egyeztetés', label: 'Egyeztetés' },
        { value: 'Meeting', label: 'Meeting' },
        { value: 'Folyamatban', label: 'Folyamatban' },
        { value: 'Support', label: 'Support' }
    ];

    const logOut = () => {
        localStorage.removeItem('token');
        window.location.reload(false);
    }

    const showMessage = (message, severity = 'success') => {
        setSnackbar({ open: true, message, severity });
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar({ ...snackbar, open: false });
    };

    async function getTaskFromJira(taskCodeInput) {
        const url = 'https://profloggerserver.develanjaro.com/getTask'
        const response = await fetch(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                taskCode: taskCodeInput,
                token: token
            })
        });

        if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.message || 'Nem sikerült lekérni a task adatait.');
        }
        return response.json();
    }

    function clear() {
        setShowAUTCheckbox("no");
        setIncludeRemaining("no");
        setDate(moment());
        setTimeSpent(0);
        setTaskCode('');
        setWorklogComment('')
    }

    async function logTime({ taskCode, task }) {
        const url = 'https://profloggerserver.develanjaro.com/logTime'
        const response = await fetch(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                taskCode: taskCode.taskCode,
                token: token,
                timeSpentSeconds: timeSpent * 60,
                started: moment(date).format().split('T')[0].concat('T11:11:11.000+0100'),
                testExecuted: moment(date).format('YYYYMMDD'),
                key: task.key,
                type: task.fields.issuetype.name,
                projectKey: task.fields.project.key,
                projectName: task.fields.project.name,
                created: task.fields.created.split('T')[0].replace('-', '').replace('-', ''),
                priority: task.fields.priority.name,
                epicname: task.fields.epicname,
                testResult: testResult,
                labels: '',
                user: JSON.parse(localStorage.getItem('token')).user,
                taskName: task.fields.summary,
                includeRemaining: includeRemaining,
                worklogComment: worklogComment,
            })
        });

        if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.message || 'Hiba a mentés során.');
        }
        
        return response.json();
    }

    const handleTaskCodeChange = (e) => {
        const newTaskCode = e.target.value.toUpperCase().trim().split("/").slice(-1)[0] || "";
        const isAUT = newTaskCode.includes("AUT");

        setTaskCode(newTaskCode);
        setShowAUTCheckbox(isAUT ? "yes" : "no");
        setIncludeRemaining(isAUT ? "yes" : "no");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (timeSpent === 0) {
            showMessage('Nem lehet a logolt idő 0 perc!', 'warning');
            return;
        }
        if (!taskCode) {
            showMessage('Nincs kiválasztott task!', 'warning');
            return;
        }

        setIsLoading(true);

        try {
            const responseTask = await getTaskFromJira(taskCode);
            const jTask = responseTask.task;

            if (jTask.fields.customfield_10006) {
                 try {
                    const epicResponse = await getTaskFromJira(jTask.fields.customfield_10006);
                    jTask.fields.epicname = epicResponse.task.fields.customfield_10005;
                 } catch (epicErr) {
                     console.warn("Nem sikerült az Epic nevet lekérni, üres marad.", epicErr);
                     jTask.fields.epicname = '';
                 }
            } else {
                jTask.fields.epicname = '';
            }

            await logTime({
                taskCode: { taskCode: taskCode },
                task: jTask
            });

            setWorklogComment('');
            showMessage('Sikeres mentés!', 'success');

        } catch (error) {
            console.error(error);
            showMessage(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    }

    const handleApiCall = async () => {
        setIsLoading(true);
        try {
            const response = await fetch('https://profloggerserver.develanjaro.com/getUserWorklogs', {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: token,
                    date: logDate.format('YYYY-MM-DD'),
                    user: JSON.parse(localStorage.getItem("token")).user,
                })
            });

            if (!response.ok) {
                 const errData = await response.json().catch(() => ({}));
                 throw new Error(errData.message || 'Hiba a logok lekérésekor.');
            }

            const data = await response.json();
            const formattedWorklogs = data.worklogs ? data.worklogs.map((worklog) => ({
                taskCode: worklog.taskCode,
                taskTitle: worklog.taskTitle,
                comments: worklog.comments,
            })) : [];
    
            setApiResult(formattedWorklogs);
            if(formattedWorklogs.length === 0) {
                showMessage('Nincs találat erre a napra.', 'info');
            }
        } catch (error) {
            console.error(error);
            showMessage(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleQuickDate = (offset) => {
        const newDate = moment().subtract(offset, 'days');
        setLogDate(newDate);
        setTimeout(() => { document.getElementById('btn-get-logs').click(); }, 100);
    };
    
    const handleCopyToClipboard = async () => {
        try {
            const clipboardText = apiResult.map((log) => `${log.taskCode} - ${log.taskTitle} - ${log.comments}`).join('\n');
            const clipboardHtml = apiResult.map((log) => `<a href="https://jira.profession.hu/browse/${log.taskCode}" target="_blank" rel="noopener noreferrer">${log.taskCode}</a> - ${log.taskTitle} - ${log.comments}`).join('<br>');
    
            const clipboardItem = new ClipboardItem({
                "text/plain": new Blob([clipboardText], { type: "text/plain" }),
                "text/html": new Blob([clipboardHtml], { type: "text/html" })
            });
    
            await navigator.clipboard.write([clipboardItem]);
            
            showMessage('Logok a vágólapra másolva!', 'success');
        } catch (error) {
            console.error('Clipboard write failed:', error);
            showMessage('Nem sikerült a másolás!', 'error');
        }
    };
    
    
    
    return (
        <div>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Notification onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Notification>
            </Snackbar>

            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Prof Logger
                    </Typography>
                    <Typography variant="subtitle1" sx={{ marginRight: 2 }}>
                        {JSON.parse(localStorage.getItem("token"))?.user}
                    </Typography>
                    <Button color="inherit" onClick={logOut}>
                        Kijelentkezés
                    </Button>
                </Toolbar>
            </AppBar>
            <Container maxWidth="lg">
                <Grid container spacing={3} marginTop={2}>
                    <Grid item xs={3} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                        <Button variant="contained" color="primary" onClick={clear} disabled={isLoading}>
                            Mindent kiürít
                        </Button>
                        {showAUTCheckbox === "yes" && 
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={includeRemaining === "yes"}
                                        onChange={(e) => setIncludeRemaining(e.target.checked ? "yes" : "no")}
                                    />
                                }
                                label="Vonódjon a remainingből"
                            />
                        }
                    </Grid>
                    <Grid item xs={6} >
                    </Grid>
                    <Grid item xs={3}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '8px' }}>
                             {[0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10].map((hour) => (
                                <Button
                                    key={hour}
                                    variant="outlined"
                                    onClick={() => setTimeSpent(hour * 60)}
                                    disabled={isLoading}
                                    style={{ minWidth: '60px' }}
                                >
                                    {hour}
                                </Button>
                            ))}
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            label="Task-kód"
                            type="text"
                            onChange={handleTaskCodeChange}
                            value={taskCode}
                            fullWidth
                            disabled={isLoading}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Teszt ideje"
                                value={date}
                                onChange={(newDate) => setDate(newDate)}
                                format="YYYY-MM-DD"
                                disabled={isLoading}
                                renderInput={(props) => <TextField {...props} fullWidth />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3}>
                        <Select
                            value={testResult}
                            onChange={(e) => setTestResult(e.target.value)}
                            fullWidth
                            disabled={isLoading}
                        >
                            {options.map((option) => (
                                <MenuItem value={option.value} key={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            label="Logolandó idő(perc)"
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            value={timeSpent}
                            onChange={(e) => setTimeSpent(parseInt(e.target.value) || 0)}
                            fullWidth
                            disabled={isLoading}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Worklog komment"
                            type="text"
                            value={worklogComment}
                            onChange={(e) => setWorklogComment(e.target.value)}
                            fullWidth
                            disabled={isLoading}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleSubmit} 
                            disabled={isLoading}
                            fullWidth
                            size="large"
                        >
                            {isLoading ? 'Mentés folyamatban...' : 'Mentés'}
                        </Button>
                    </Grid>
                    
                    <Grid item xs={12}><hr /></Grid> 

                    <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Dátum"
                                value={logDate}
                                onChange={(newDate) => setLogDate(newDate)}
                                format="YYYY-MM-DD"
                                disabled={isLoading}
                                renderInput={(props) => <TextField {...props} fullWidth />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={2}>
                        <Button 
                            id="btn-get-logs"
                            variant="contained" 
                            color="primary" 
                            onClick={handleApiCall} 
                            disabled={isLoading}
                            fullWidth
                        >
                            Logok lekérése
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="outlined" disabled={isLoading} onClick={() => handleQuickDate(0)} fullWidth>
                            Mai
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="outlined" disabled={isLoading} onClick={() => handleQuickDate(1)} fullWidth>
                            Tegnapi
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="outlined" disabled={isLoading} onClick={() => handleQuickDate(3)} fullWidth>
                            3 nappal ezelőtti
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button 
                            variant="contained" 
                            color="success" 
                            fullWidth 
                            disabled={apiResult.length === 0} 
                            onClick={handleCopyToClipboard}
                        >
                            Másolás
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <div>
                            {apiResult.length === 0 && <Typography variant="body2" color="textSecondary">Itt jelennek majd meg a lekérdezett logok.</Typography>}
                            {apiResult.map((log, index) => (
                                <div key={index}>
                                    <a href={`https://jira.profession.hu/browse/${log.taskCode}`} target="_blank" rel="noreferrer">
                                        {log.taskCode}
                                    </a> - {log.taskTitle} - {log.comments}
                                </div>
                            ))}
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}


export default Home;